import { useMutation, useQueryClient } from '@tanstack/react-query'
import { unassignRequirementFromPosition } from 'api/company/position/requirement'
import { positionsKeys } from 'queries/positions'
import { requirementDataForPositionKey } from './keys'

type Response = Awaited<ReturnType<typeof unassignRequirementFromPosition>>
type Variables = Omit<
  Parameters<typeof unassignRequirementFromPosition>[0],
  'positionId'
>

export const useUnassignRequirementFromPositionMutation = (
  positionId: number
) => {
  const queryClient = useQueryClient()
  return useMutation<Response, Error, Variables>({
    mutationFn: ({ requirementId }) =>
      unassignRequirementFromPosition({ positionId, requirementId }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: requirementDataForPositionKey(positionId),
        }),
        queryClient.invalidateQueries({
          queryKey: positionsKeys.detail(positionId),
        }),
      ])
    },
  })
}
